import type { RouteRecordRaw } from 'vue-router'

const feedbackRoutes: RouteRecordRaw[] = [
  {
    path: 'feedback',
    redirect: '/feedback/items',
    children: [
      {
        path: 'items',
        name: 'feedback-items',
        component: () => import('@/views/feedback/FeedbackList.vue'),
        meta: { title: '反馈列表', permission: 'feedback:view' }
      },
      {
        path: 'items/:id',
        name: 'feedback-detail',
        component: () => import('@/views/feedback/FeedbackDetail.vue'),
        meta: { title: '反馈详情', permission: 'feedback:view' }
      },
      {
        path: 'apps',
        name: 'feedback-apps',
        component: () => import('@/views/feedback/FeedbackAppList.vue'),
        meta: { title: '接入应用', permission: 'feedback:app:view' }
      },
      {
        path: 'apps/:appId/product-bindings',
        name: 'feedback-product-bindings',
        component: () => import('@/views/feedback/FeedbackProductBinding.vue'),
        meta: { title: '产品绑定规则', permission: 'feedback:app:view' }
      }
    ]
  }
]

export default feedbackRoutes
